export default __webpack_public_path__ + "static/media/1701.a59997aa.png";